import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TestFormComponent } from './test-form.component';
import { ReactiveFormsModule } from '@angular/forms';
import { DirtyFormGuard } from '@tmhcc-ng-lib/framwork/grid';

const routes: Routes = [
  {
    path: '',
    component: TestFormComponent,
    canDeactivate: [DirtyFormGuard]
  }
];

@NgModule({
  providers: [],
  declarations: [TestFormComponent],
  imports: [ReactiveFormsModule, RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TestFormModule {}
